import {MainLayout} from "../../../layouts/MainLayout.tsx";
import AccountProvider from "../../../../providers/Account/AccountProvider.tsx";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import apiNet from "../../../../newApi/apiNet.ts";
import {useNotification} from "../../../../providers/NotificationProvider.tsx";
import {NotificationStatus} from "../../../notification/Notification.tsx";
import {IPromotionBanner} from "../../../../interfaces/templates/bannerHome/IPromotionBanner.ts";
import BannersTemplate1Form from "./forms/BannersTemplate1Form.tsx";
import UtilsHelper from "../../../../helpers/utilsHelper.ts";
import Button from "../../../buttons/Button.tsx";
import {ButtonSize, ButtonVariant} from "../../../../types/button.ts";

const AccountPromotionBannersEditPage = () => {
    const _notificationService = useNotification();
    const _navigate = useNavigate();

    const {banner_id} = useParams();
    const [banner, setBanner] = useState<IPromotionBanner>();
    useEffect(() => {
        UtilsHelper.changeWindowDocumentTitle("Edytowanie banneru");
        (async () => {
            if (banner_id) {
                try {
                    const response = await apiNet.getPromotionBanner(banner_id);
                    setBanner(response.data);
                } catch (e) {
                    _notificationService.showNotification("Niepowodzenie", "Wystąpił błąd z pobraniem danych dla szablonu. Spróbuj ponownie za kilka minut.", NotificationStatus.failure);
                }
            }
        })()
    }, [banner_id]);

    const removePromotionBanner = async () => {
        if (banner_id && confirm("Czy napewno chcesz usunąć banner?")) {
            try {
                await apiNet.deletePromotionBanner(banner_id);
                _notificationService.showNotification("Powodzenie", "Baner został pomyślnie usunięty", NotificationStatus.success);
            } catch (e) {
                _notificationService.showNotification("Niepowodzenie", "Coś poszło nie tak podczas usuwania baneru. Spróbuj ponownie za chwilę.", NotificationStatus.failure);
            } finally {
                _navigate(-1);
            }

        }
    }

    return (
        <MainLayout>
            <AccountProvider>
                <div className={"bg-neutral-900 p-6 md:p-10 max-w-lg shadow-3xl rounded-3xl"}>
                    {banner && banner.templateId === 1 &&
                        <BannersTemplate1Form mode={"edit"} bannerData={banner}/>
                    }
                    {import.meta.env.VITE_BACKEND_TYPE == 'php' &&
                        <>
                            <div className={"flex justify-between items-center my-4 mx-3"}>
                                <div className={"h-0.5 flex-1 bg-neutral-500"}></div>
                                <p className={"mx-4"}>lub</p>
                                <div className={"h-0.5 flex-1 bg-neutral-500"}></div>
                            </div>
                            <Button variant={ButtonVariant.TERTIARY} size={ButtonSize.LARGE}
                                    onClick={async () => await removePromotionBanner()}
                                    className={"w-full bg-red-500 hover:bg-red-600"}>Usuń</Button>
                        </>
                    }
                </div>
            </AccountProvider>
        </MainLayout>
    );
};

export default AccountPromotionBannersEditPage;